import { Link } from "react-router-dom";

var css = `
.tally-mkt { min-height:100vh; font-family:'Hanken Grotesk',-apple-system,sans-serif; background:#FBF9F3; color:#23241E; }
.tally-mkt-nav { position:sticky; top:0; z-index:100; background:rgba(251,249,243,.92); backdrop-filter:blur(12px); border-bottom:1px solid #E8E2D5; }
.tally-mkt-nav-in { max-width:1100px; margin:0 auto; padding:0 24px; display:flex; align-items:center; justify-content:space-between; height:64px; }
.tally-mkt-nav-in img { height:28px; }
.tally-mkt-nav-links { display:flex; align-items:center; gap:28px; }
.tally-mkt-nav-links a { font-size:15px; font-weight:500; color:#6f6f64; text-decoration:none; transition:color .2s; }
.tally-mkt-nav-links a:hover { color:#23241E; }
.tally-mkt-nav-r { display:flex; align-items:center; gap:14px; }
.tally-mkt-nav-r .login { font-size:15px; font-weight:600; color:#23241E; text-decoration:none; }
.tally-mkt-nav-r .cta { display:inline-flex; align-items:center; height:40px; padding:0 22px; border-radius:50px; background:#14432B; color:#F4EFE4; font-size:14.5px; font-weight:700; text-decoration:none; transition:background .2s; }
.tally-mkt-nav-r .cta:hover { background:#1a5838; }
@media(max-width:768px) { .tally-mkt-nav-links { display:none; } }

.tally-mkt-footer { border-top:1px solid #E8E2D5; padding:56px 24px 40px; }
.tally-mkt-footer-in { max-width:1100px; margin:0 auto; }
.tally-mkt-footer-top { display:flex; justify-content:space-between; flex-wrap:wrap; gap:40px; margin-bottom:40px; }
.tally-mkt-footer-brand img { height:24px; margin-bottom:12px; }
.tally-mkt-footer-brand p { font-size:14px; color:#6f6f64; max-width:260px; line-height:1.6; }
.tally-mkt-footer-cols { display:flex; gap:56px; flex-wrap:wrap; }
.tally-mkt-footer-col h4 { font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:.5px; color:#23241E; margin:0 0 14px; }
.tally-mkt-footer-col a { display:block; font-size:14px; color:#6f6f64; text-decoration:none; margin-bottom:10px; transition:color .2s; }
.tally-mkt-footer-col a:hover { color:#23241E; }
.tally-mkt-footer-bottom { border-top:1px solid #E8E2D5; padding-top:24px; display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:12px; }
.tally-mkt-footer-bottom p { font-size:13px; color:#a1a1aa; margin:0; }
.tally-mkt-footer-bottom a { font-size:13px; color:#a1a1aa; text-decoration:none; margin-left:20px; }
.tally-mkt-footer-bottom a:hover { color:#23241E; }
`;

export function MarketingNav() {
  return (
    <nav className="tally-mkt-nav">
      <div className="tally-mkt-nav-in">
        <Link to="/"><img src="/tally-logo.png" alt="Tally" /></Link>
        <div className="tally-mkt-nav-links">
          <Link to="/pricing">Pricing</Link>
          <Link to="/articles">Blog</Link>
          <Link to="/affiliates">Affiliates</Link>
          <Link to="/docs">Help</Link>
        </div>
        <div className="tally-mkt-nav-r">
          <Link to="/login" className="login">Log in</Link>
          <Link to="/signup" className="cta">Start free trial</Link>
        </div>
      </div>
    </nav>
  );
}

export function MarketingFooter() {
  return (
    <footer className="tally-mkt-footer">
      <div className="tally-mkt-footer-in">
        <div className="tally-mkt-footer-top">
          <div className="tally-mkt-footer-brand">
            <img src="/tally-logo.png" alt="Tally" />
            <p>See your money clearly. Simple budgeting built for Canadians.</p>
          </div>
          <div className="tally-mkt-footer-cols">
            <div className="tally-mkt-footer-col">
              <h4>Product</h4>
              <Link to="/pricing">Pricing</Link>
              <Link to="/demo">Demo</Link>
              <Link to="/signup">Sign Up</Link>
            </div>
            <div className="tally-mkt-footer-col">
              <h4>Resources</h4>
              <Link to="/articles">Blog</Link>
              <Link to="/docs">Help Center</Link>
              <Link to="/affiliates">Affiliates</Link>
            </div>
            <div className="tally-mkt-footer-col">
              <h4>Company</h4>
              <a href="mailto:hello@usetally.ca">Contact</a>
              <Link to="/advisor/login">Advisor Portal</Link>
            </div>
          </div>
        </div>
        <div className="tally-mkt-footer-bottom">
          <p>&copy; {new Date().getFullYear()} Tally. Built in Canada.</p>
          <div>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export function MarketingLayout({ children }) {
  return (
    <div className="tally-mkt">
      <style>{css}</style>
      <MarketingNav />
      {children}
      <MarketingFooter />
    </div>
  );
}
